document.addEventListener('DOMContentLoaded', () => {
	const backToTopBtn = document.querySelector('#backToTop');

	// 1. Create a "sentinel" element at the very top of the body
	const scrollSentinel = document.createElement('div');
	scrollSentinel.style.position = 'absolute';
	scrollSentinel.style.top = '0';
	document.body.prepend(scrollSentinel);

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				backToTopBtn.classList.add('is-visible');
			} else {
				backToTopBtn.classList.remove('is-visible');
			}
		});
	});

	observer.observe(scrollSentinel);

	backToTopBtn.addEventListener('click', () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	});
});
